import React from 'react'
import PropTypes from 'prop-types'
import { Demo } from './Demo'

export function Article(props) {
  const { index, heading, image, imageDescription, children, demo } = props

  return (
    <article>
      <div className="article-index">{index + 1}</div>
      <h2>{heading}</h2>
      <section>
        <img
          src={image}
          alt={imageDescription}
          loading="lazy"
          className="article-image"
        />
        {children ?? null}
      </section>
      {typeof demo !== 'undefined' && <Demo {...demo} />}
    </article>
  )
}

Article.propTypes = {
  index: PropTypes.node.isRequired,
  heading: PropTypes.node.isRequired,
  image: PropTypes.node.isRequired,
  imageDescription: PropTypes.string.isRequired,
  children: PropTypes.node,
  demo: PropTypes.shape({
    story: PropTypes.node.isRequired,
    frontend: PropTypes.node,
    canister: PropTypes.node,
  }),
}
